/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions and reducers used to manipulate application state
import { setCurrentContent, completeQueue } from 'redux/actions/queue_status';
import { activateContent } from 'redux/actions/content_status';
import { setInViewStatus, setIntegrationTypeAndURL, setOutOfContent } from 'redux/actions/embed_status';
import { setSessionData, getUserGeoIp, optUserIn } from 'redux/actions/session_status';
import { awardPoints, awardPointsWithRewards, permitRewards } from 'redux/actions/rewards';
import { displayScreen } from 'redux/actions/screen_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import App from 'components/app';
// batching action creator that enables batching subscriber notifications for an array of actions.
import { batchActions } from 'redux-batched-actions';
/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/


/* ========== ~~~~~~~~~~ APP : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, queueStatus, embedStatus, contentData, sessionStatus, rewards }) => ({
    inViewSettings: settings.embedSettings.inView,
    inViewStatus: embedStatus.inView,
    userOptedIn: sessionStatus.userOptedIn,
    embedUUID: settings.embedSettings.uuid,
    rewardsPermitted: rewards.status.rewardsPermitted,
    queueStatus,
    contentStatus,
    embedStatus,
    contentData,
    sessionStatus,
    embedSettings: settings.embedSettings,
    contentSettings: settings.contentSettings,
    rewardSettings: rewards.settings,
    outOfContent: embedStatus.outOfContent,
    dataFetchingPermitted: sessionStatus.dataFetchingPermitted,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
});
// map actions
const mapDispatchToProps = dispatch => ({
	setAndActivateContent: contentId => dispatch(batchActions([setCurrentContent(contentId), activateContent(contentId)])),
    completeQueue: () => dispatch(completeQueue()),
    setInViewStatus: inViewStatus => dispatch(setInViewStatus(inViewStatus)),
    setIntegrationTypeAndURL: integrationTypeAndURL => dispatch(setIntegrationTypeAndURL(integrationTypeAndURL)),
    setSessionData: sessionData => dispatch(setSessionData(sessionData)),
    getUserGeoIp: () => dispatch(getUserGeoIp()),
    awardPoints: numberOfPoints => dispatch(awardPoints(numberOfPoints)),
    awardPointsWithRewards: (numberOfPoints, numberOfRewards, rewardsPhase) =>
        dispatch(awardPointsWithRewards(numberOfPoints, numberOfRewards, rewardsPhase)),
    optUserIn: () => dispatch(optUserIn()),
    displayScreen: (screen) => dispatch(displayScreen(screen)),
    permitRewards: () => dispatch(permitRewards()),
    setOutOfContent: status => dispatch(setOutOfContent(status))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
